import { css, keyframes } from 'emotion';
import React from 'react';

const pageLoaderStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f7f7f7;

  display: grid;
  place-items: center;

  z-index: 200;
`;

const spin = keyframes`
  from {
    transform: rotateZ(0deg);
  } to {
    transform: rotateZ(360deg);
  }
`;

const spinnerStyle = css`
  width: 100px;
  height: 100px;

  background: transparent;
  border-radius: 100%;
  border: 5px solid #72659f;
  border-right-color: transparent;
  animation: ${spin} 1s infinite linear;
`;

export const PageLoader = () => {
  return (
    <div className={pageLoaderStyle}>
      <div className={spinnerStyle} />
    </div>
  );
};
